import { Injectable } from '@angular/core';
import { LegendItem } from './legend-item';

import { LayerService } from '../../services/layers/layer.service'

import { Top10mapLegendComponent } from './top10map-legend/top10map-legend.component';
import { Top25mapLegendComponent } from './top25map-legend/top25map-legend.component';
import { Top50mapLegendComponent } from './top50map-legend/top50map-legend.component';
import { Top250mapLegendComponent } from './top250map-legend/top250map-legend.component';
import { NoLegendComponent } from './no-legend/no-legend.component';

import { map, filter, find, switchMap } from 'rxjs/operators';
import { Layer } from '../../models/layer';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { Observable } from 'rxjs';
import { LegendDialogComponent } from './legend-dialog/legend-dialog.component';

import { MatDialog } from '@angular/material/dialog';
import { NgiCartowebTopoBeLegendComponent } from './ngi-cartoweb-topo-be-legend/ngi-cartoweb-topo-be-legend.component';
import { NgiCartowebCrossborderBeLegendComponent } from './ngi-cartoweb-crossborder-be-legend/ngi-cartoweb-crossborder-be-legend.component';
import { NgiCartowebCrossborderBwBeLegendComponent } from './ngi-cartoweb-crossborder-bw-be-legend/ngi-cartoweb-crossborder-bw-be-legend.component';
import { NgiCartowebTopoBwBeLegendComponent } from './ngi-cartoweb-topo-bw-be-legend/ngi-cartoweb-topo-bw-be-legend.component';
import { Landcover100mapLegendComponent } from './landcover100map-legend/landcover100map-legend.component';

@Injectable({
  providedIn: 'root'
})

export class LegendService {
  public legendLayers 
  constructor(
    public layerService: LayerService,
    public dialog: MatDialog,
  ) { 

    this.legendLayers = this.getLegendLayers().subscribe(legendLayers => this.legendLayers = legendLayers);
  }

  public static legendCollection = {
    'ngi.cartoweb.topo.be': new LegendItem(NgiCartowebTopoBeLegendComponent),
    'ngi.cartoweb.topo_bw.be': new LegendItem(NgiCartowebTopoBwBeLegendComponent),
    'crossborder.topo': new LegendItem(NgiCartowebCrossborderBeLegendComponent),
    'crossborder.topo_bw': new LegendItem(NgiCartowebCrossborderBwBeLegendComponent),
    'top10map': new LegendItem(Top10mapLegendComponent),
    'top25map': new LegendItem(Top25mapLegendComponent),
    'top50map': new LegendItem(Top50mapLegendComponent),
    'landcover100map': new LegendItem(Landcover100mapLegendComponent),
    'top250map': new LegendItem(Top250mapLegendComponent),
    'nolegend': new LegendItem(NoLegendComponent)
  }

  public static legendDialogCollection = {
    'ngi.cartoweb.topo.be': NgiCartowebTopoBeLegendComponent,
    'ngi.cartoweb.topo_bw.be': NgiCartowebTopoBwBeLegendComponent,
    'crossborder.topo': NgiCartowebCrossborderBeLegendComponent,
    'crossborder.topo_bw': NgiCartowebCrossborderBwBeLegendComponent,
    'top10map': Top10mapLegendComponent, Top10mapLegendComponent,
    'top25map': Top25mapLegendComponent, Top25mapLegendComponent,
    'top50map': Top50mapLegendComponent,
    'landcover100map': Landcover100mapLegendComponent,
    'top250map': Top250mapLegendComponent,
    'nolegend': NoLegendComponent
  } 

  getlegendCollection(): object {
    return LegendService.legendCollection;
  }

  getLegendId(activeLayerId) {
    return (this.legendLayers.map(layer => layer.id).includes(activeLayerId)) ? LegendService.legendDialogCollection[activeLayerId] ? activeLayerId : 'nolegend' : 'nolegend';
  }

  public getLegendLayers(): Observable<Layer[]> {
    return this.layerService.getLayersList().pipe(map((layers: Layer[]) => layers.filter((layer: Layer) => layer.hasLegend)))
  }
  activeLayerLabel;
  setActiveLayerLabel(layerId: string) {
    this.layerService.findAvailableBusinessLayerById(layerId).subscribe(layer => this.activeLayerLabel = layer.label);
  }

  public openDialog(): void {    
    let activeLayerId = this.layerService.getActiveBaselayerId();
    this.setActiveLayerLabel(activeLayerId);
    
    const dialogRef = this.dialog.open(LegendDialogComponent, {
      closeOnNavigation: true,
      panelClass: 'legend-dialog',
      width: '100%',
      maxWidth: '100vw !important',
      height: '100%',
      maxHeight: '100vh !important',
      data: {
        activeLayerLabel: this.activeLayerLabel,
        activeLayerId: activeLayerId,
        legendItem: LegendService.legendDialogCollection[this.getLegendId(activeLayerId)]
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      //console.log('The dialog was closed ');
      //this.toggleVisibility(null);
    });
  }

}